// src/components/PsicomotricidadeInfo.tsx
import React from 'react';
import '../../styles/especialidades.css';
import '../../styles/psicomotricidade.css';

const NeurologistaInfo: React.FC = () => (
    <section className="about_psicomotricidade">
        <div className="teste_zoom_two">
            <div className="about_text_psicomotricidade">
                <h2 className='sub_title'><b>Cuidando do cérebro em desenvolvimento.</b></h2>
                <br />
                <p>A Neurologia Pediátrica é a especialidade médica responsável por acompanhar o desenvolvimento do sistema nervoso em crianças e adolescentes. Desde o nascimento até o final da adolescência, o neurologista infantil avalia como as funções cerebrais impactam o comportamento, a linguagem, a cognição, o aprendizado e o desenvolvimento motor.</p>
                <br />
                <p>Com uma abordagem integrada e acolhedora, a neurologia pediátrica busca identificar precocemente alterações neurológicas e promover intervenções eficazes que favoreçam um crescimento saudável, respeitando o ritmo individual de cada criança e considerando o contexto familiar, escolar e emocional.</p>
                <br />
                <p><b>Quando procurar um neurologista pediátrico?</b></p>
                <br />
                
                    <li>Atrasos no desenvolvimento motor, como sentar, andar ou falar fora da idade esperada;</li>
                    <li>Dificuldades na aprendizagem, rendimento escolar abaixo do esperado ou desatenção persistente;</li>
                    <li>Sinais de TDAH (Transtorno de Déficit de Atenção e Hiperatividade);</li>
                    <li>Crises convulsivas, epilepsia ou desmaios recorrentes;</li>
                    <li>Distúrbios do sono, como insônia, sonambulismo ou terrores noturnos;</li>
                    <li>Diagnóstico ou suspeita de paralisia cerebral, autismo, síndromes genéticas ou doenças neuromusculares.</li>
                
                <br />
                <p><b>Benefícios do acompanhamento neurológico infantil</b></p>
                <br />

                    <li>Identificação precoce de alterações neurológicas e comportamentais;</li>
                    <li>Planejamento de estratégias terapêuticas que promovem autonomia e inclusão;</li>
                    <li>Melhora na qualidade de vida da criança e da família com orientações personalizadas;</li>
                    <li>Acompanhamento contínuo do desenvolvimento neurológico com foco preventivo;</li>
                    <li>Integração com equipes multidisciplinares, incluindo psicólogos, fonoaudiólogos e terapeutas ocupacionais.</li>
                
                <br />  
                <p><b>Neurologia pediátrica: promovendo desenvolvimento, confiança e equilíbrio</b></p>
                <br />
                <p>Investir em acompanhamento neurológico desde cedo é garantir que as crianças tenham o suporte necessário para crescer com saúde, segurança e bem-estar. Ao transformar sinais de alerta em oportunidades de intervenção, a neurologia pediátrica permite que cada criança alcance seu potencial máximo, superando desafios e construindo uma trajetória de desenvolvimento plena e equilibrada.</p>
                <br />
            </div>
        </div>
    </section>
);

export default NeurologistaInfo;